import { render } from "./MirabelAccordion.vue?vue&type=template&id=15a12f78&scoped=true"
import script from "./MirabelAccordion.vue?vue&type=script&lang=js"
export * from "./MirabelAccordion.vue?vue&type=script&lang=js"

import "./MirabelAccordion.vue?vue&type=style&index=0&id=15a12f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a12f78"]])

export default __exports__